import DispoTermsPage from 'info/dispensary-terms';

export default DispoTermsPage;
